import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import RegisterPage from "../pages/register/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import TermsAndConditionsPage from "../pages/terms-and-conditions/page";
import CommunityGuidelinesPage from "../pages/community-guidelines/page";
import AuraTestPage from "../pages/aura-test/page";
import AuraysAdminPage from "../pages/aurays-admin/page";
import EventAdminPage from "../pages/event-admin/page";
import CheckinScannerPage from "../pages/checkin-scanner/page";
import RegistrationOpsPage from "../pages/registration-ops/page";
import EmailQueuePage from "../pages/email-queue/page";
import EventsPage from "../pages/events/page";
import EventDetailPage from "../pages/event-detail/page";
import TicketPage from "../pages/ticket/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsAndConditionsPage />,
  },
  {
    path: "/community-guidelines",
    element: <CommunityGuidelinesPage />,
  },
  {
    path: "/love-aura-test",
    element: <AuraTestPage />,
  },
  {
    path: "/events",
    element: <EventsPage />,
  },
  {
    path: "/events/:slug",
    element: <EventDetailPage />,
  },
  {
    path: "/tickets/:token",
    element: <TicketPage />,
  },
  {
    path: "/aurays-admin",
    element: <AuraysAdminPage />,
  },
  {
    path: "/event-admin",
    element: <EventAdminPage />,
  },
  {
    path: "/checkin-scanner",
    element: <CheckinScannerPage />,
  },
  {
    path: "/registration-ops",
    element: <RegistrationOpsPage />,
  },
  {
    path: "/email-queue",
    element: <EmailQueuePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
